import { render } from "./LeadReportSummary.vue?vue&type=template&id=509f2ea6&scoped=true"
import script from "./LeadReportSummary.vue?vue&type=script&lang=js"
export * from "./LeadReportSummary.vue?vue&type=script&lang=js"

import "./LeadReportSummary.vue?vue&type=style&index=0&id=509f2ea6&scoped=true&lang=css"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509f2ea6"]])

export default __exports__